import fs from 'node:fs'
import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { resolveProjectPaths } from '@next-adapter/config/paths/resolve-project-paths.js'
import { renderCoreEmailProviderIndex } from './render-core-email-provider-index.js'
import { renderCoreEmailProvider } from './render-core-email-provider.js'
import { renderCoreStorageProviderIndex } from './render-core-storage-provider-index.js'
import { renderCoreStorageProvider } from './render-core-storage-provider.js'

export function writeCoreProviderIndexes(cwd: string, config: ResolvedBetterstartConfig): void {
  const paths = resolveProjectPaths(config)
  const emailPath = path.join(cwd, ...paths.adminActionsDir.split('/'), 'email', 'index.ts')
  const emailProviderPath = path.join(
    cwd,
    ...paths.adminActionsDir.split('/'),
    'email',
    'provider.ts'
  )
  const storagePath = path.join(cwd, ...paths.adminActionsDir.split('/'), 'storage', 'index.ts')
  const storageProviderPath = path.join(
    cwd,
    ...paths.adminActionsDir.split('/'),
    'storage',
    'provider.ts'
  )

  fs.mkdirSync(path.dirname(emailPath), { recursive: true })
  fs.writeFileSync(emailPath, renderCoreEmailProviderIndex(config), 'utf-8')
  fs.writeFileSync(emailProviderPath, renderCoreEmailProvider(config), 'utf-8')

  fs.mkdirSync(path.dirname(storagePath), { recursive: true })
  fs.writeFileSync(storagePath, renderCoreStorageProviderIndex(config), 'utf-8')
  fs.writeFileSync(storageProviderPath, renderCoreStorageProvider(config), 'utf-8')
}
